import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { User } from '@stylehaven/components';
import { SharedApplicationState, UserState } from '../shared-state.interface';
import { userAdapter } from './user.reducer';

export const getUserState: MemoizedSelector<
    object,
    UserState,
    DefaultProjectorFn<UserState>
> = createFeatureSelector<UserState>('user');

const { selectAll } = userAdapter.getSelectors(getUserState);
export { selectAll as selectAllUsers };

export const selectUserFeature: (state: SharedApplicationState) => UserState = (state: SharedApplicationState) =>
    state.user;

export const userSelector: MemoizedSelector<
    object,
    User | undefined,
    DefaultProjectorFn<User | undefined>
> = createSelector(selectAll, (items: User[]) => {
    if (items.length > 0) {
        return items[0];
    } else {
        return undefined;
    }
});
